<template>
<panel>
  <p slot="header">
    Adresy e-mail
  </p>
  <p slot="actions">
    <ui-button type="flat" icon="add_circle" color="primary" @click="$router.push({name: 'admin.emails.import'})" >Importuj adresy e-mail</ui-button>
    <ui-button type="flat" icon="file_download" color="primary" @click="$router.push({name: 'admin.emails.export-emails'})" >Eksportuj adresy e-mail</ui-button>
    <ui-button type="flat" color="primary" @click="$router.push({name: 'admin.email-groups.dashboard'})" >Grupy adresów</ui-button>
  </p>
  <emails-list></emails-list>


</panel>

</template>
<script>
import Emails from '../../services/Emails'

export default {
  data () {
    return {
      item: Emails.getBaseItem()
    }
  }
}
</script>



// WEBPACK FOOTER //
// Dashboard.vue?9ab19fe0